import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
//import BuscadorEfectorFacturacion from 'src/components/liquidaciones/UI/BuscadorEfectorFacturacion';
import { setearValorEnPractica } from '../../../actions/autorizaciones/Autorizaciones';
import { AssignmentReturn, Delete } from '@material-ui/icons';
import { Box, Card, CardContent, Checkbox, Fab, FormControl, FormControlLabel, FormGroup, Popover, Typography } from '@material-ui/core';
import { AutoCompleteEfectorFacturacion } from '../../liquidaciones/UI/AutoCompleteEfectorFacturacion';
import { setEfectorSeleccionado } from '../../../actions/liquidaciones/liquidaciones';

const DebitoCapita = ({ label = "", mouseEvent = false, practica, autorizaciones = true,
    setDebitoCapita, setEfectorFacturacionDebitoCapita, cargaLineaSinPrecarga = false }) => {
    const dispatch = useDispatch();

    const { efectorSeleccionado } = useSelector((state) => state.liquidaciones);

    const [efectorFacturacion, setEfectorFacturacion] = useState(practica.efectorFacturacionDebitoCapita)
    const [anchorEl, setAnchorEl] = useState(null);

    useEffect(() => {
        if (anchorEl)
            dispatch(setEfectorSeleccionado(practica.efectorFacturacionDebitoCapita));
    }, [anchorEl]);

    useEffect(() => {
        setEfectorFacturacion(efectorSeleccionado);
    }, [efectorSeleccionado]);

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const idPopSeguimiento = open ? 'simple-popover' : undefined;

    const handleSeguimientoSave = () => {
        if (autorizaciones) {
            dispatch(
                setearValorEnPractica(
                    practica?.idCodNom,
                    "debitoCapita",
                    true
                )
            );
            dispatch(
                setearValorEnPractica(
                    practica?.idCodNom,
                    "idEfectorFactDebitoCapita",
                    efectorFacturacion.idEfectorFacturacion
                )
            );
            dispatch(
                setearValorEnPractica(
                    practica?.idCodNom,
                    "efectorFacturacionDebitoCapita",
                    efectorFacturacion
                )
            );
        } else {
            setDebitoCapita(true);
            setEfectorFacturacionDebitoCapita(efectorFacturacion);
        }
        handlePopoverClose();
    };

    const handleSeguimientoDelete = () => {
        if (autorizaciones) {
            dispatch(
                setearValorEnPractica(
                    practica?.idCodNom,
                    "debitoCapita",
                    false
                )
            );
            dispatch(
                setearValorEnPractica(
                    practica?.idCodNom,
                    "idEfectorFactDebitoCapita",
                    null
                )
            );
            dispatch(
                setearValorEnPractica(
                    practica?.idCodNom,
                    "efectorFacturacionDebitoCapita",
                    null
                )
            );
        } else {
            setDebitoCapita(false);
            setEfectorFacturacionDebitoCapita(null);
        }
        setEfectorFacturacion(null);
        handlePopoverClose();
    };

    return (
        <>
            {mouseEvent === false ? (
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <FormControl component="fieldset">
                        <FormGroup aria-label="position" row>
                            <FormControlLabel
                                value="end"
                                label={(autorizaciones || cargaLineaSinPrecarga) && label}
                                control={<Checkbox checked={practica.debitoCapita} />}
                                labelPlacement="end"
                                aria-describedby={idPopSeguimiento}
                                onClick={handlePopoverOpen}
                            />
                        </FormGroup>
                    </FormControl>
                    <Popover
                        id={idPopSeguimiento}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handlePopoverClose}
                        anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                        }}
                        transformOrigin={{
                            vertical: "center",
                            horizontal: "left",
                        }}
                        PaperProps={{
                            style: { width: "500px", height: "220px" },
                        }}
                    >
                        <Card sx={{
                            flexGrow: 1,
                        }} variant="outlined">
                            <CardContent>
                                <Typography
                                    color="textSecondary"
                                    gutterBottom
                                >
                                    Debito a la Capita
                                </Typography>
                                <AutoCompleteEfectorFacturacion todos dontExecuteFetch />
                                {/*<BuscadorEfectorFacturacion
                                    value={efectorFacturacion}
                                    soloCapitados={true}
                                    soloActivos={true}
                                    setValue={(value) => {
                                        if(value) setEfectorFacturacion(value);
                                    }}
                                />*/}
                            </CardContent>
                            <Box
                                className="boxFab"
                                display="flex"
                                justifyContent="space-evenly"
                                alignItems="center"
                                sx={{ width: "100%" }}
                            >
                                <Box
                                    textAlign="center"
                                >
                                    <Typography
                                        color="textSecondary"
                                        gutterBottom
                                        style={{ fontSize: ".8rem" }}
                                    >
                                        Eliminar
                                    </Typography>
                                    <Fab
                                        size="small"
                                        onClick={handleSeguimientoDelete}
                                        color="primary"
                                        aria-label="delete"
                                        disabled={!practica.debitoCapita}
                                    >
                                        <Delete style={{ fontSize: "1.8rem" }} />
                                    </Fab>
                                </Box>
                                <Box
                                    textAlign="center"
                                >
                                    <Typography
                                        color="textSecondary"
                                        gutterBottom
                                        style={{ fontSize: ".8rem" }}
                                    >
                                        Guardar
                                    </Typography>
                                    <Fab
                                        size="small"
                                        disabled={!efectorFacturacion}
                                        onClick={handleSeguimientoSave}
                                        color="primary"
                                        aria-label="add"
                                    >
                                        <AssignmentReturn
                                            style={{ fontSize: "1.8rem" }}
                                        />
                                    </Fab>
                                </Box>
                            </Box>
                        </Card>
                    </Popover>
                </Box>
            ) : (
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <FormControl component="fieldset">
                        <FormGroup aria-label="position" row>
                            {
                                practica.debitoCapita
                                    ?
                                    <FormControlLabel
                                        value="end"
                                        label={(autorizaciones || cargaLineaSinPrecarga) && label}
                                        control={<Checkbox checked={practica.debitoCapita ? true : false} />}
                                        labelPlacement="end"
                                        aria-owns={open ? 'mouse-over-popover' : undefined}
                                        aria-haspopup="true"
                                        onMouseEnter={handlePopoverOpen}
                                        onMouseLeave={handlePopoverClose}
                                        disabled
                                    />
                                    :
                                    <FormControlLabel
                                        value="end"
                                        label={label}
                                        control={<Checkbox checked={practica.debitoCapita ? true : false} />}
                                        labelPlacement="start"
                                        aria-owns={open ? 'mouse-over-popover' : undefined}
                                        aria-haspopup="true"
                                        disabled
                                    />
                            }
                        </FormGroup>
                    </FormControl>
                    <Popover
                        id="mouse-over-popover"
                        sx={{
                            pointerEvents: 'none',
                        }}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handlePopoverClose}
                        disableRestoreFocus
                        anchorOrigin={{
                            vertical: 'center',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'center',
                            horizontal: 'center',
                        }}
                        PaperProps={{
                            style: { width: "500px", height: "130px" },
                        }}
                    >
                        <Card sx={{
                            flexGrow: 1,
                        }} variant="outlined">
                            <CardContent>
                                <Typography
                                    color="textSecondary"
                                    gutterBottom
                                >
                                    Debito a la Capita
                                </Typography>
                                <AutoCompleteEfectorFacturacion todos dontExecuteFetch />
                                {/*<BuscadorEfectorFacturacion
                                    value={efectorFacturacion}
                                    soloCapitados={true}
                                    soloActivos={true}
                                    setValue={(value) => {
                                        if(value) setEfectorFacturacion(value);
                                    }}
                                />*/}
                            </CardContent>
                        </Card>
                    </Popover>
                </Box>
            )}
        </>
    );
}

export default DebitoCapita;